module.exports = __webpack_public_path__ + "newstatic/img/two-time.c871d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/two-time.png
// module id = nC7d
// module chunks = 1